<template>
  <div>
    <page-main :tableData="tableData" :disabled="disabled" ref="main">
      <page-header
        ref="header"
        slot="header"
        class="mb-2"
        :disabled="disabled"
        @add="chooseTechDictVisible = true"
      />
    </page-main>

    <ChooseTechDict
      :visible.sync="chooseTechDictVisible"
      :title="$l('dialog_title_techChoose') || '工艺选择'"
      @confirm="techDictConfirm"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import ChooseTechDict from '../choose-tech-dict'
export default {
  components: { PageHeader, PageMain, ChooseTechDict },
  props: {
    tableData: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { chooseTechDictVisible: false }
  },
  methods: {
    async techDictConfirm(data) {
      if (!data || !data.length) return
      const $main = this.$refs.main
      const { rows } = await $main.insert(data)
      $main.setActiveCell(rows[0], 'labourCost')
    },
    async validate() {
      return await this.$refs.main.validate()
    },
    async getTableData() {
      return await this.$refs.main.getTableData()
    },
  },
}
</script>
